import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { getConfig, makeDataUrl } from '../../shared/utils'

import JumpToStep from '../../shared/components/JumpToStep'
import FormSection from '../../shared/components/FormSection'

export default
class OverviewSection extends Component {

  static propTypes = {
    address: PropTypes.shape({
      latitude: PropTypes.string,
      location: PropTypes.string,
      longitude: PropTypes.string,
      region: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
      street: PropTypes.string,
      zip: PropTypes.string,
    }),
    description: PropTypes.string,
    drivingInstructions: PropTypes.string,
    email: PropTypes.string,
    entryFeeAdults: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    entryFeeGroups: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    entryFeePupils: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    equipments: PropTypes.object,
    fax: PropTypes.string,
    goToSection: PropTypes.func,
    id: PropTypes.number,
    images: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    isFieldGroupDirty: PropTypes.func,
    links: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    minGroupSize: PropTypes.number,
    openingHours: PropTypes.string,
    phone: PropTypes.string,
    qs: PropTypes.object,
    show: PropTypes.bool,
    steps: PropTypes.array,
    website: PropTypes.string,

  }

  renderList(data, listName, className) {
    return (data && data.length)
      ? (
        <ul className={className}>
          {(data || [])
            .map((entry) => {
              return entry
            })
            .map((entry) => ('pivot' in entry ? entry.pivot : entry))
            .map((entry) => {
              return (
                <li key={entry.id}>
                  {
                    getConfig(listName)
                    // eslint-disable-next-line eqeqeq
                      .filter((value) => entry.id == value.id)
                      .map((value) => {
                        if ('amount' in entry) {
                          return (
                            <span key={value.title}>
                              <span className="info-list-label">
                                {value.title}
                                :&nbsp;
                              </span>
                              {entry.amount}
                            </span>
                          )
                        }

                        return value.title
                      })
                  }
                </li>
              )
            })}
        </ul>
      )
      : <em>Keine Daten vorhanden</em>
  }

  render() {

    const {
      name,
      address,
      qs,
      equipments,
      phone,
      fax,
      email,
      images,
      links,
      website,
      description,
      openingHours,
      drivingInstructions,
      entryFeeAdults,
      entryFeePupils,
      entryFeeGroups,
      minGroupSize,
      show,
      steps,
      goToSection
    } = this.props

    return (
      <FormSection
        title="6. Übersicht"
        className="overview"
        show={show}
      >
        <div className="data-group">
          <JumpToStep
            onClick={goToSection}
            steps={steps}
            which="address"
          >
            <h3>
              1. Anschrift
            </h3>
            <strong>{name}</strong>
            <dl>
              <dt>Straße, Hausnummer:</dt>
              <dd>
                {address.street}
                {' '}
                {address.number}
              </dd>
              <dt>PLZ, Ort:</dt>
              <dd>
                {address.zip}
                {' '}
                {address.location}
              </dd>
            </dl>
          </JumpToStep>
        </div>

        <div className="data-group">
          <JumpToStep
            onClick={goToSection}
            steps={steps}
            which="information"
          >
            <h3>
              2. Informationen
            </h3>
            <dl>
              <dt>Telefon:</dt>
              <dd>
                {phone}
              </dd>
              <dt>Fax:</dt>
              <dd>
                {fax}
              </dd>
              <dt>Website:</dt>
              <dd>
                {website}
              </dd>
              <dt>
                E-Mail:
              </dt>
              <dd>
                {email}
              </dd>
              <dt>
                Beschreibung:
              </dt>
              <dd>
                {description}
              </dd>
            </dl>
          </JumpToStep>
        </div>

        <div className="data-group">
          <JumpToStep
            onClick={goToSection}
            steps={steps}
            which="visit"
          >
            <h3>
              3. Besuch
            </h3>
            <dl>
              <dt>
                Öffnungszeiten
              </dt>
              <dd>
                <pre>{openingHours}</pre>
              </dd>
              <dt>
                Anfahrt:
              </dt>
              <dd>
                {drivingInstructions}
              </dd>
            </dl>

            <div><strong>Kosten</strong></div>
            <dl>
              <dt>
                Eintritt Erwachsene:
              </dt>
              <dd>
                {entryFeeAdults}
                {' '}
                Euro
              </dd>
              <dt>
                Eintritt Schüler:
              </dt>
              <dd>
                {entryFeePupils}
                {' '}
                Euro
              </dd>
              <dt>
                Eintritt Schulklassen:
              </dt>
              <dd>
                {entryFeeGroups}
                {' '}
                Euro
              </dd>
              <dt>
                Anzahl der kostenfreien Begleitpersonen
              </dt>
              <dd>
                {minGroupSize}
                {' '}
                Euro
              </dd>
            </dl>
          </JumpToStep>
        </div>

        <div className="data-group">
          <JumpToStep
            onClick={goToSection}
            steps={steps}
            which="equipment"
          >
            <h3>
              4. Ausstattung und Maßnahmen zur Qualitätssicherung
            </h3>

            <strong>Ausstattung:</strong>
            <br />

            {this.renderList(equipments, 'list_equipment', 'info-list')}

            <strong>Maßnahmen zur Qualitätssicherung:</strong>
            <br />

            {this.renderList(qs, 'list_qs', 'info-list')}
          </JumpToStep>
        </div>

        <div className="data-group">
          <JumpToStep
            onClick={goToSection}
            steps={steps}
            which="media"
          >
            <h3>
              5. Medien
            </h3>

            <ul className="file-list files">
              {(links || []).map((link) => (
                <li
                  key={`link-${link.url || (link.file && link.file.name)}`}
                >
                  <div>
                    <a href={`${link.url}`}>
                      {
                        link.description
                  || (link.pivot && link.pivot.description ? link.pivot.description : '')
                      }
                    </a>
                &nbsp;
                    <small>
                      (
                      {link.name}
                      )
                    </small>
                  </div>
                </li>
              ))}
            </ul>

            <ul className="file-list images">
              {(images || []).map((image) => (
                <li
                  key={`image-${image.url || (image.file && image.file.name)}`}
                >
                  <div
                    className="thumbnail"
                    style={{
                      backgroundImage: `url(${makeDataUrl(
                        image,
                        images !== undefined ? images : null
                      )})`
                    }}
                  />
                  <div>{image.description || (image.pivot && image.pivot.description ? image.pivot.description : '')}</div>
                </li>
              ))}
            </ul>
          </JumpToStep>
        </div>

      </FormSection>
    )

  }
}



// WEBPACK FOOTER //
// ./src/museum/components/06-OverviewSection.js